<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Generate Daily Proctor Schedule for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="generateDPS()">
      <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
        <p>{{modelError}}</p>
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Daily Start Time</label>
        <input type="time" class="form-control file-select" [(ngModel)]="DpsAuto.utcDailyStartTime"
          [ngModelOptions]="{ standalone: true }" />
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Daily End Time</label>
        <input type="time" class="form-control file-select" [(ngModel)]="DpsAuto.utcDailyEndTime"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Max No. of Candidate Per time frame</label>
        <input type="number" min="0" class="form-control file-select" [(ngModel)]="DpsAuto.maxCandidateNoPerDay"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="form-check mb-3 mr-0 col-md-10">
        <input class="form-check-input" type="checkbox" [(ngModel)]="DpsAuto.excludeWeekends"
          [ngModelOptions]="{ standalone: true }">
        <label class="form-check-label" for="flexCheckDefault">
          Exclude Weekends
        </label>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Generate
      </button>
    </form>
  </div>
</div>